import React, {Component} from 'react';
import PageTitle from '../../../common/page-title';
import SectionTitle from '../../../common/section-title';
import {Row, Col, Button, FormGroup} from 'react-bootstrap';
import {Form, Control, Errors, actions, track} from 'react-redux-form';
import ArrowButton from '../../../common/button-arrow';
import Number from '../../../common/form/spinner';
import {getExpiry, saveExpiry, viewExpire} from '../../../../actions/points';
import {connect} from 'react-redux';

class PointsExpiry extends Component {

  constructor(props) {
    super(props);
    this.state = {
      id: '',
      day:   '',
      month: ''
    };

  }

  componentWillMount() {
    this.props.dispatch(getExpiry());
  }

  onPointsExpiryClick = () => {
    this.props.dispatch(viewExpire());
  };

  onSubmit = (payload) => {
    this.props.dispatch(actions.submitFields('deep.points_expiry', saveExpiry(payload)));
  };

  render() {
    return (
      <div className="container-fluid">
        <PageTitle>Points expiry</PageTitle>
        <Col md={12}>
          <Row>
            <ArrowButton className="float-right"
                         arrow={false}
                         submit={false}
                         onClick={this.onPointsExpiryClick}>Download points expiry</ArrowButton>
          </Row>
        </Col>
        <SectionTitle>Points expiry settings</SectionTitle>
        <Col md={12}>
          <Row>
            <Form model="deep.points_expiry" onSubmit={this.onSubmit}>

              <Errors className="errors" model="deep.points_expiry"/>

              <Col md={12}>
                <Row>
                  <FormGroup controlId="month">
                    Month to expiry: <Number model="deep.points_expiry.month"
                                             min={1}
                                             value={this.props.month}/>
                  </FormGroup>
                </Row>
              </Col>
              <Col md={12}>
                <Row>
                  <FormGroup controlId="day">
                    Day of month to run expiry: <Number model="deep.points_expiry.day"
                                                        min={1}
                                                        max={28}
                                                        value={this.props.day}/>
                  </FormGroup>
                </Row>
              </Col>
              <Col md={12}>
                <Row>
                  <ArrowButton className="float-right" color="red"
                  >save</ArrowButton>
                </Row>
              </Col>
            </Form>
          </Row>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    id: state.points.point_expiry && state.points.point_expiry.id || 1,
    day:   state.points.point_expiry.attributes && state.points.point_expiry.attributes.day || 1,
    month: state.points.point_expiry.attributes && state.points.point_expiry.attributes.month || 1,
  };
};

export default connect(mapStateToProps)(PointsExpiry);


// WEBPACK FOOTER //
// ./src/components/admin/points/points-expiry/index.jsx